import { render } from "./BaseModalCancelButton.vue?vue&type=template&id=54387018&scoped=true"
const script = {}

import "./BaseModalCancelButton.vue?vue&type=style&index=0&id=54387018&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54387018"]])

export default __exports__